import { Component, OnInit } from '@angular/core';
import { Plugins } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { AlertService } from 'src/app/providers/alert.service';
const { Clipboard } = Plugins;

@Component({
  selector: 'app-refer-friend',
  templateUrl: './refer-friend.component.html',
  styleUrls: ['./refer-friend.component.scss'],
})
export class ReferFriendComponent implements OnInit {
  downloadLink = "https://covid-innovation-221486.web.app/downloads"
  // https://theretrieverapp.com/downloads
  // https://covid-innovation-221486.web.app/login

  constructor(
    public modalController: ModalController,
    private alertSvc: AlertService) { }

  ngOnInit() { }

  referFriend() {
    Clipboard.write({
      string: this.downloadLink
    })
    const toast = document.createElement('ion-toast');
      toast.setAttribute("role", "alert");
      toast.setAttribute("aria-live", "polite");
      toast.setAttribute("aria-label", " ");
      toast.message = '<ion-icon name="checkmark"></ion-icon>      Link Copied'
      toast.position = 'top';
      toast.duration = 3000;
      toast.cssClass = "success-message";
      document.body.appendChild(toast);
      toast.present();
    
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
